import React, { useEffect, useState, useRef } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { MdOutline3DRotation, MdOutlineVideoLibrary } from "react-icons/md";
// import img1 from "../../Assests_Url/image-teach.png";
// import img2 from "../../Assests_Url/image-video.png";

import img1 from '../../Assests_Url/UTeach_12th/Enhance Keywords/1 Tap the highlighted Keyword.png'
import img2 from '../../Assests_Url/UTeach_12th/Enhance Keywords/2 View the additional information in the left side pane.png'
import img3 from '../../Assests_Url/UTeach_12th/Enhance Keywords/3 Tap another keyword.png'
import img4 from '../../Assests_Url/UTeach_12th/Enhance Keywords/4 View the additional information.png'

import img11 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/1.png'
import img12 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/2.png'
import img13 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/3.png'
import img14 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/4.png'
import img15 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/5.png'
import img16 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/6.png'
import img17 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/7.png'
import img18 from '../../Assests_Url/UTeach_12th/Explanation & Concept videos/8.png'

import img21 from '../../Assests_Url/UTeach_12th/3D Model/1. Go to a 3D model ex. Embryo Sac.png'
import img22 from '../../Assests_Url/UTeach_12th/3D Model/2. Go to session 2.png'
import img23 from '../../Assests_Url/UTeach_12th/3D Model/3. Open  a KATBOOK. Ex. Biology 12th class Unit 6.png'
import img24 from '../../Assests_Url/UTeach_12th/3D Model/4. Rotate the 3D model to view 360 degrees.png'

import img31 from '../../Assests_Url/UTeach_12th/2D animation/1. Go to a 2D animation Law of Dominance.png'
import img32 from '../../Assests_Url/UTeach_12th/2D animation/2. Go to Session 3.png'
import img33 from '../../Assests_Url/UTeach_12th/2D animation/3. Go to Unit 7.png'
import img34 from '../../Assests_Url/UTeach_12th/2D animation/4. Open  a KATBOOK. Ex. Biology 12th class.png'
import img35 from '../../Assests_Url/UTeach_12th/2D animation/5. Play the 2D animation.png'

import img41 from '../../Assests_Url/UTeach_12th/virtual lab/1. Open a Katbook.png'
import img42 from '../../Assests_Url/UTeach_12th/virtual lab/2. Go to a session with Virtual experiment and open it 3.png'
import img43 from '../../Assests_Url/UTeach_12th/virtual lab/3. Go to a session with Virtual experiment and open it 4.jpg'
import img44 from '../../Assests_Url/UTeach_12th/virtual lab/4. Go to a session with Virtual experiment and open it.png'
import img45 from '../../Assests_Url/UTeach_12th/virtual lab/5. View of Virtual experiment screen 1.jpg'
import img46 from '../../Assests_Url/UTeach_12th/virtual lab/6. View of Virtual experiment screen 2.jpg'
import img47 from '../../Assests_Url/UTeach_12th/virtual lab/7. View of Virtual experiment screen 3.jpg'
import img48 from '../../Assests_Url/UTeach_12th/virtual lab/8. Details of Virtual experiment.jpg'
import img49 from '../../Assests_Url/UTeach_12th/virtual lab/9. Virtual experiment - on selection materials 1.jpg'
import img40 from '../../Assests_Url/UTeach_12th/virtual lab/10. Virtual experiment - instructions 2.jpg'
import img411 from '../../Assests_Url/UTeach_12th/virtual lab/11. Virtual experiment - instructions 3.jpg'
import img421 from '../../Assests_Url/UTeach_12th/virtual lab/12. Virtual experiment - instructions 4.jpg'

import img51 from '../../Assests_Url/UTeach_12th/Interactive exercises/1 Fill in the blanks with audio input.png'
import img52 from '../../Assests_Url/UTeach_12th/Interactive exercises/2 Tap mic icon - say the answer then Check.png'
import img53 from '../../Assests_Url/UTeach_12th/Interactive exercises/3 Type the answer then Check.png'


import { IoArrowUndoCircle, IoColorWandOutline } from "react-icons/io5";
import { PiVideoFill } from "react-icons/pi";
import mic from "../../Assests_Url/2d.png";
import vl from "../../Assests_Url/virtual_labs.png";
import iex from "../../Assests_Url/Inter_exer.png";
import { useLocation, useNavigate } from "react-router-dom";
import enhance from "../../Assests_Url/Enhan_Key_Img12th.jpg";
import modal from "../../Assests_Url/3D MODEL_12th.jpg"
import animation from "../../Assests_Url/2D ANIMATION_12th.jpg"
import Inter_Exercise from "../../Assests_Url/INTERACTIVE EXERCISE_12th.jpg"
import Carousel from "../Carousel/Carousel";



const UTeachStandard = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  allCountries
}) => {

  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);
  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const v1 = useRef(null);
  const v2 = useRef(null);
  const v3 = useRef(null);
  const v4 = useRef(null);
  const v5 = useRef(null);
  const v6 = useRef(null);

  const pauseOthers = (current) => {
    [v1, v2, v3, v4, v5, v6].forEach((ref) => {
      if (ref.current && ref.current !== current) {
        ref.current.pause();
      }
    });
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  const sampleData1 = [
    {
      img: img1,
      title: "Tap the highlighted Keyword",
    },
    {
      img: img2,
      title: "View the additional information in the left side pane",
    },
    {
      img: img3,
      title: "Tap another keyword",
    },
    {
      img: img4,
      title: "View the additional information",
    }
  ];

  const sampleData2 = [
    {
      img: img11,
      title: "Concept Video within base book",
    },
    {
      img: img12,
      title: "Both base book and Concept video",
    },
    {
      img: img13,
      title: "Explanation Video within base book",
    },
    {
      img: img14,
      title: "Filteration of Meta content",
    },
    {
      img: img15,
      title: "Unit or chapter selection",
    },
    {
      img: img16,
      title: "Resource Selection",
    },
    {
      img: img17,
      title: "Search result",
    },
    {
      img: img18,
      title: "Searched concept video",
    }
  ];

  const sampleData3 = [
    {
      img: img21,
      title: "Go to a 3D model ex. Embryo Sac",
    },
    {
      img: img22,
      title: "Go to session 2",
    },
    {
      img: img23,
      title: "Open a KATBOOK. Ex. Biology 12th class Unit 6",
    },
    {
      img: img24,
      title: "Rotate the 3D model to view 360 degrees",
    }
  ];

  const sampleData4 = [
    {
      img: img31,
      title: "Go to a 2D animation Law of Dominance",
    },
    {
      img: img32,
      title: "Go to session 3",
    },
    {
      img: img33,
      title: "Go to unit 7",
    },
    {
      img: img34,
      title: "Open a KATBOOK. Ex. Biology 12th class",
    },
    {
      img: img35,
      title: "Play the 2D animation",
    }
  ];

  const sampleData5 = [
    {
      img: img41,
      title: "Open a Katbook",
    },
    {
      img: img42,
      title: "Go to a session with Virtual experiment and open it 1",
    },
    {
      img: img43,
      title: "Go to a session with Virtual experiment and open it 2",
    },
    {
      img: img44,
      title: "Go to a session with Virtual experiment and open it 3",
    },
    {
      img: img45,
      title: "View of Virtual experiment screen 1",
    },
    {
      img: img46,
      title: "View of Virtual experiment screen 2",
    }, 
    {
      img: img47,
      title: "View of Virtual experiment screen 3",
    }, 
    {
      img: img48,
      title: "Details of Virtual experiment",
    }, 
    {
      img: img49,
      title: "Virtual experiment - on selection materials 1",
    }, 
    {
      img: img40,
      title: "Virtual experiment - instructions 2",
    }, 
    {
      img: img411,
      title: "Virtual experiment - instructions 3",
    }, 
    {
      img: img421,
      title: "Virtual experiment - instructions 4",
    },
  ];

  const sampleData6 = [
    {
      img: img51,
      title: "Fill in the blanks with audio input",
    },
    {
      img: img52,
      title: "Tap mic icon - say the answer then Check",
    },
    {
      img: img53,
      title: "Type the answer then Check",
    }
  ];

  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          AdminregisterModal={AdminregisterModal}
          setAdminregisterModal={setAdminregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
          selectedLang={selectedLang}
          setSelectedLang={setSelectedLang}
          allCountries={allCountries}
        />
      </div>

      <div className="container-uteach">
        <div className="pt-5">
          {/* <div className='found-font text-center pb-4'>
            UTeach Higher Standard Books
          </div> */}
          <div className="d-flex align-items-center justify-content-between text-center pb-4">
            <div>
              <IoArrowUndoCircle
                size={30}
                className="back-arrow"
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className="found-font">
              {/* UTeach Higher Standard Books */}
              <div className="found-font">
                {lang === "en"
                  ? "UTeach Higher Standard Books"
                  : lang === "hi"
                    ? "यूटीच उच्चतर मानक पुस्तकें"
                    : null
                }
              </div>
            </div>
            <div></div>
          </div>

          <div className="d-flex flex-column gap-3 pb-4">
            <div className="text-foun-font text-center">
              {/* When logged in from a Higher Standards Teacher’s ID, the
              following advanced features and benefits will be available: */}
              {lang === "en"
                ? "When logged in from a Higher Standards Teacher’s ID, the following advanced features and benefits will be available:"
                : lang === "hi"
                  ? "उच्चतर मानक शिक्षक आईडी से लॉग इन करने पर, निम्नलिखित उन्नत सुविधाएँ और लाभ उपलब्ध होंगे:"
                  : null
              }
            </div>
            <div className="text-foun-font text-center">
              {/* KATBOOK enhances the teaching experience for secondary and
              senior secondary levels by combining NCERT/CBSE-aligned
              content with advanced digital teaching aids. */}
              {lang === "en"
                ? "KATBOOK enhances the teaching experience for secondary and senior secondary levels by combining NCERT/CBSE-aligned content with advanced digital teaching aids."
                : lang === "hi"
                  ? "कैटबुक, एनसीईआरटी/सीबीएसई-संरेखित सामग्री को उन्नत डिजिटल शिक्षण सहायक सामग्री के साथ जोड़कर माध्यमिक और उच्चतर माध्यमिक स्तर के शिक्षण अनुभव को बेहतर बनाता है।"
                  : null
              }
            </div>
          </div>

          <div className="d-flex flex-column align-items-center gap-3">
            <div className="meta-font">
              {/* The Power of Meta Content */}
              {lang === "en"
                ? "The Power of Meta Content"
                : lang === "hi"
                  ? "मेटा कंटेंट की क्षमता"
                  : null
              }
            </div>
            <div className="text-foun-font text-center">
              {/* NCERT KATBOOKS for higher classes are powered with
              state-of-the-art teaching resources curated by subject experts and
              global content creators. */}
              {lang === "en"
                ? "NCERT KATBOOKS for higher classes are powered with state-of-the-art teaching resources curated by subject experts and global content creators."
                : lang === "hi"
                  ? "उच्च कक्षाओं के लिए एनसीईआरटी कैटबुक्स विषय विशेषज्ञों और वैश्विक कंटेंट निर्माताओं द्वारा तैयार किए गए अत्याधुनिक शिक्षण संसाधनों से संचालित हैं।"
                  : null
              }
            </div>
            <div className="text-foun-font text-center">
              {/* Teachers can use these advanced, ready-to-use digital resources to
              simplify complex concepts in science, mathematics, computer
              science, and much more */}
              {lang === "en"
                ? "Teachers can use these advanced, ready-to-use digital resources to simplify complex concepts in science, mathematics, computer science, and much more"
                : lang === "hi"
                  ? "शिक्षक विज्ञान, गणित, कंप्यूटर विज्ञान और अन्य विषयों में जटिल अवधारणाओं को सरल बनाने के लिए इन उन्नत, उपयोग में आसान डिजिटल संसाधनों का उपयोग कर सकते हैं।"
                  : null
              }
            </div>
          </div>

          <div className="pt-5">
            <div className="d-flex flex-column gap-5">

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 1. Enhanced Keywords{" "} */}
                    {lang === "en"
                      ? "1. Enhanced Keywords "
                      : lang === "hi"
                        ? "1. उन्नत कीवर्ड "
                        : null
                    }
                    <IoColorWandOutline size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Important terms, formulae, and concepts are highlighted as
                    keywords. Teachers can click on them to open a side-by-side
                    screen showing definitions, explanations, derivations, and
                    related references. */}
                    {lang === "en"
                      ? "Important terms, formulae, and concepts are highlighted as keywords. Teachers can click on them to open a side-by-side screen showing definitions, explanations, derivations, and related references."
                      : lang === "hi"
                        ? "महत्वपूर्ण शब्द, सूत्र और अवधारणाएँ कीवर्ड के रूप में हाइलाइट किए गए हैं। शिक्षक उन पर क्लिक करके अगल-बगल स्क्रीन खोल सकते हैं जिसमें परिभाषाएँ, व्याख्याएँ, व्युत्पत्तियाँ और संबंधित संदर्भ दिखाई देंगे।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Acts as a quick reference during class discussions. */}
                        {lang === "en"
                          ? "Acts as a quick reference during class discussions."
                          : lang === "hi"
                            ? "कक्षा में चर्चा के दौरान एक त्वरित संदर्भ के रूप में कार्य करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Ensures consistent and standardised explanation of key
                        terms */}
                        {lang === "en"
                          ? "Ensures consistent and standardised explanation of key terms."
                          : lang === "hi"
                            ? "प्रमुख शब्दों की सुसंगत और मानकीकृत व्याख्या सुनिश्चित करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData1} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v1} className="video-css" width="540" controls onPlay={() => pauseOthers(v1.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758984789456982016_enhancekeywords12thT1.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 2. Concept & Explanation Videos (Embedded){" "} */}
                    {lang === "en"
                      ? "2. Concept & Explanation Videos (Embedded) "
                      : lang === "hi"
                        ? "2. अवधारणा और स्पष्टीकरण वीडियो (एम्बेडेड) "
                        : null
                    }
                    <PiVideoFill size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Concept & Explanation Videos are embedded from within the
                    KATBOOK to explain difficult or abstract concepts. Teachers
                    can play, pause, or project these videos in full screen
                    directly without leaving the KATBOOK window. */}
                    {lang === "en"
                      ? "Concept & Explanation Videos are embedded from within the KATBOOK to explain difficult or abstract concepts. Teachers can play, pause, or project these videos in full screen directly without leaving the KATBOOK window."
                      : lang === "hi"
                        ? "कठिन या अमूर्त अवधारणाओं को समझाने के लिए अवधारणा और स्पष्टीकरण वीडियो KATBOOK में एम्बेड किए गए हैं। शिक्षक KATBOOK विंडो से बाहर निकले बिना सीधे इन वीडियो को पूर्ण स्क्रीन पर चला, रोक या प्रोजेक्ट कर सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Provides an instant teaching aid for abstract or complex
                        topics. */}
                        {lang === "en"
                          ? "Provides an instant teaching aid for abstract or complex topics."
                          : lang === "hi"
                            ? "अमूर्त या जटिल विषयों के लिए तत्काल शिक्षण सहायता प्रदान करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Saves preparation time by removing the need for external
                        sources. */}
                        {lang === "en"
                          ? "Saves preparation time by removing the need for external sources."
                          : lang === "hi"
                            ? "बाहरी स्रोतों की आवश्यकता को समाप्त करके तैयारी के समय की बचत करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Standardize the method of teaching for all teachers and
                        schools. */}
                        {lang === "en"
                          ? "Standardize the method of teaching for all teachers and schools."
                          : lang === "hi"
                            ? "सभी शिक्षकों और विद्यालयों के लिए शिक्षण पद्धति का मानकीकरण करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData2} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v2} className="video-css" width="540" controls onPlay={() => pauseOthers(v2.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758984605025046528_explainationconceptvideo12thT2.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 3. 3D Models & Activities{" "} */}
                    {lang === "en"
                      ? "3. 3D Models & Activities "
                      : lang === "hi"
                        ? "3. 3D मॉडल और गतिविधियाँ "
                        : null
                    }
                    <MdOutline3DRotation size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Interactive 3D models of molecules, body systems, geometric
                    structures, and lab apparatus are available from within the
                    KATBOOK. Teachers can rotate, zoom, and demonstrate them in
                    class. */}
                    {lang === "en"
                      ? "Interactive 3D models of molecules, body systems, geometric structures, and lab apparatus are available from within the KATBOOK. Teachers can rotate, zoom, and demonstrate them in class."
                      : lang === "hi"
                        ? "अणुओं, शरीर प्रणालियों, ज्यामितीय संरचनाओं और प्रयोगशाला उपकरणों के इंटरैक्टिव 3D मॉडल KATBOOK में उपलब्ध हैं। शिक्षक इन्हें घुमा सकते हैं, ज़ूम कर सकते हैं और कक्षा में प्रदर्शित कर सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Improves understanding of abstract diagrams and
                        scientific structures. */}
                        {lang === "en"
                          ? "Improves understanding of abstract diagrams and scientific structures."
                          : lang === "hi"
                            ? "अमूर्त आरेखों और वैज्ञानिक संरचनाओं की समझ में सुधार करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Makes complex concepts more tangible and interactive. */}
                        {lang === "en"
                          ? "Makes complex concepts more tangible and interactive."
                          : lang === "hi"
                            ? "जटिल अवधारणाओं को अधिक मूर्त और इंटरैक्टिव बनाता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData3} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v3} className="video-css" width="540" controls onPlay={() => pauseOthers(v3.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758984851817893888_3Dmodel12thT3.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 4. 2D Animations{" "} */}
                    {lang === "en"
                      ? "4. 2D Animations "
                      : lang === "hi"
                        ? "4. 2D एनिमेशन "
                        : null
                    }
                    <img src={mic} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Step-by-step animations illustrate processes such as
                    chemical reactions, biological functions, physical laws, and
                    much more */}
                    {lang === "en"
                      ? "Step-by-step animations illustrate processes such as chemical reactions, biological functions, physical laws, and much more"
                      : lang === "hi"
                        ? "चरण-दर-चरण एनिमेशन रासायनिक प्रतिक्रियाओं, जैविक कार्यों, भौतिक नियमों और बहुत कुछ जैसी प्रक्रियाओं को दर्शाते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Simplifies difficult concepts by breaking them into
                        visual sequences. */}
                        {lang === "en"
                          ? "Simplifies difficult concepts by breaking them into visual sequences."
                          : lang === "hi"
                            ? "कठिन अवधारणाओं को दृश्य अनुक्रमों में विभाजित करके उन्हें सरल बनाते हैं।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Assists teachers in explaining processes clearly and
                        systematically. */}
                        {lang === "en"
                          ? "Assists teachers in explaining processes clearly and systematically."
                          : lang === "hi"
                            ? "प्रक्रियाओं को स्पष्ट और व्यवस्थित रूप से समझाने में शिक्षकों की सहायता करते हैं।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData4} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v4} className="video-css" width="540" controls onPlay={() => pauseOthers(v4.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758984986559909888_2Danimation12thT4.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 5. Virtual Labs{" "} */}
                    {lang === "en"
                      ? "5. Virtual Labs "
                      : lang === "hi"
                        ? "5. वर्चुअल लैब (डिजिटल शिक्षण वातावरण) "
                        : null
                    }
                    <img src={vl} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Fully simulated laboratory experiments with a step by step
                    interactive methodology is available from within the
                    KATBOOK. This environment enables students to perform
                    experiments digitally in Physics, Chemistry, and Biology. */}
                    {lang === "en"
                      ? "Fully simulated laboratory experiments with a step by step interactive methodology is available from within the KATBOOK. This environment enables students to perform experiments digitally in Physics, Chemistry, and Biology."
                      : lang === "hi"
                        ? "चरण-दर-चरण इंटरैक्टिव कार्यप्रणाली के साथ पूरी तरह से सिम्युलेटेड प्रयोगशाला प्रयोग KATBOOK में उपलब्ध हैं। यह वातावरण छात्रों को भौतिकी, रसायन विज्ञान और जीव विज्ञान में डिजिटल रूप से प्रयोग करने में सक्षम बनाता है।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Offers repeatable, and cost-effective practice for
                        experiments. */}
                        {lang === "en"
                          ? "Offers repeatable, and cost-effective practice for experiments."
                          : lang === "hi"
                            ? "प्रयोगों के लिए दोहराने योग्य और किफ़ायती अभ्यास प्रदान करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Ensures practical learning continues even in
                        resource-constrained settings */}
                        {lang === "en"
                          ? "Ensures practical learning continues even in resource-constrained settings"
                          : lang === "hi"
                            ? "यह सुनिश्चित करता है कि संसाधन-विहीन परिस्थितियों में भी व्यावहारिक शिक्षा जारी रहे।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData5} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v5} className="video-css" width="540" controls onPlay={() => pauseOthers(v5.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758984169513684992_VirtualLab12thT5.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 6. Interactive Exercises{" "} */}
                    {lang === "en"
                      ? "6. Interactive Exercises "
                      : lang === "hi"
                        ? "6. इंटरैक्टिव अभ्यास "
                        : null
                    }
                    <img src={iex} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Session-based interactive activities such as classification,
                    drag-and-drop tasks, and application-based problem-solving
                    exercises are included. Teachers can involve students in
                    solving these activities during class. */}
                    {lang === "en"
                      ? "Session-based interactive activities such as classification, drag-and-drop tasks, and application-based problem-solving exercises are included. Teachers can involve students in solving these activities during class."
                      : lang === "hi"
                        ? "सत्र-आधारित इंटरैक्टिव गतिविधियाँ जैसे वर्गीकरण, ड्रैग-एंड-ड्रॉप कार्य, और अनुप्रयोग-आधारित समस्या-समाधान अभ्यास शामिल हैं। शिक्षक कक्षा के दौरान छात्रों को इन गतिविधियों को हल करने में शामिल कर सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Promotes higher-order thinking and concept application. */}
                        {lang === "en"
                          ? "Promotes higher-order thinking and concept application."
                          : lang === "hi"
                            ? "उच्च-स्तरीय सोच और अवधारणा अनुप्रयोग को बढ़ावा देता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Increases student participation and classroom
                        engagement. */}
                        {lang === "en"
                          ? "Increases student participation and classroom engagement."
                          : lang === "hi"
                            ? "छात्रों की भागीदारी और कक्षा में उनकी सहभागिता को बढ़ाता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData6} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v6} className="video-css" width="540" controls onPlay={() => pauseOthers(v6.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758984656031977472_interactiveexrcise12thT6.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  );
};

export default UTeachStandard;
